module.exports = __webpack_public_path__ + "img/isFinished.d4f86c4c.png";